import { format } from 'date-fns';

export const formatIsoDate = (date) => format(date, 'yyyy-MM-dd');

export const parseDateValue = (value) => {
  if (!value) {
    return null;
  }
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return null;
  }
  return parsed;
};

export const getAbsenceDateLimits = () => {
  const today = new Date();
  const minDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const maxDate = new Date(today.getFullYear() + 1, 11, 31);

  return {
    minDate,
    maxDate,
    minDateString: formatIsoDate(minDate),
    maxDateString: formatIsoDate(maxDate),
  };
};

export const clampDateToRange = (value, minDate, maxDate) => {
  const parsed = parseDateValue(value);
  if (!parsed) {
    return '';
  }

  if (parsed < minDate) {
    return formatIsoDate(minDate);
  }

  if (parsed > maxDate) {
    return formatIsoDate(maxDate);
  }

  return formatIsoDate(parsed);
};

export const getLowerBoundDate = (value, minDate) => {
  const parsed = parseDateValue(value);
  if (!parsed || parsed < minDate) {
    return minDate;
  }
  return parsed;
};

export const getUpperBoundDate = (value, maxDate) => {
  const parsed = parseDateValue(value);
  if (!parsed || parsed > maxDate) {
    return maxDate;
  }
  return parsed;
};
